<template>
  <v-col lg="6">
    <br/><br/>
    <v-container fluid>
      <h1 class="mx-1">New booking or quote </h1>
      <v-row>
        <v-col>
          <p>Enter your waste address in the field below </p>
        <vuetify-google-autocomplete
            filled
            append-icon="mdi-map-marker"
            class="location"
            id="location"
            ref="location"
            type="address"
            :enable-geolocation="true"
            autofocus
            placeholder="Your waste address..."
            v-on:placechanged="locationChange"
            v-model="capturedAddress"
            country="usa"
        >

        </vuetify-google-autocomplete>
        </v-col>
      </v-row>
      <v-row v-if="this.show">
        <v-col xs="16" sm="16" md="3">
          <v-text-field
          type="number"
          label="Postal Code"
          v-model="postCode"
          @change="checkPostalCode"
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" class="mx-1">
        <v-col align="center">
          <v-btn
            block
            height="55"
            style="border-radius: 30px;"
            v-bind:disabled="!canProceed"
            v-on:click="proceed"
            color="primary"
        >Continue</v-btn>
        </v-col> 
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
export default {
  name: "Address",
  props: {
      locationChangeCallback: Function
  },
  data () {
    return {
      canProceed: false,
      location: {},
      capturedAddress: '',
      postCode: '',
      show: false
    }
  },
  methods: {
    locationChange(to) {
        this.canProceed = true;
        this.location = to;
        if (this.location.postal_code){
          this.show = false;
        }
        else{
          this.show = true;
        }
    },
    checkPostalCode(){
      if(this.postCode == '' || !this.postCode){
        alert('Please enter the post code for your address');
        this.canProceed = false;
      }
      else{
        this.canProceed = true;
      }
    },
    async proceed() {
      if (!this.location.postal_code && this.postCode.length != 4){
        this.canProceed = false;
        alert('Please enter correct post code for your address');
      }
      else{
        this.canProceed = true;
        this.locationChangeCallback(this.location, this.capturedAddress, this.postCode);
      }
    }
  }
}
</script>

<style scoped>
.location{
  font-size: 23px;

}

</style>
